// extracted by mini-css-extract-plugin
module.exports = {"MealItemForm":"MealItemForm_MealItemForm__268gW"};